/* ==========================================================================
   Lockett Labs phone app bar, 2026
   Markup: snippets/ll-mobile-tabbar.liquid. Styles: assets/llmt-tabbar.css.

     1. the bar: the ink that follows the current tab across page loads, Home
        back to the top, pressed feedback, prefetch, out of the way while typing
     2. watchlist badge
     3. basket: count, running total, and the ring towards free UK delivery
     4. the Shop sheet: open, drag to dismiss, and the drill-down into a game's
        series and sets, built from the header's game panels
     5. the search sheet's "New in store" list, from the header's search hints

   The search sheet itself is driven by assets/ll-mobile-app.js, which binds to
   .llmt__tab[href*="/search"]. Merchant data reaches the page through
   textContent only.
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-llmt]');
  if (!bar || bar.__llmt) return;
  bar.__llmt = true;

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var calm = mq('(prefers-reduced-motion: reduce)');
  var store = {
    get: function (area, k) { try { return window[area].getItem(k); } catch (e) { return null; } },
    set: function (area, k, v) { try { window[area].setItem(k, v); } catch (e) {} }
  };
  var svgNS = 'http://www.w3.org/2000/svg';
  var icon = function (d, cls) {
    var s = document.createElementNS(svgNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    d.split('|').forEach(function (p) {
      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', p);
      s.appendChild(path);
    });
    return s;
  };
  var nut = function () {
    var s = document.createElementNS(svgNS, 'svg');
    s.setAttribute('viewBox', '-50 -50 100 100');
    s.setAttribute('class', 'llh-nut');
    s.setAttribute('aria-hidden', 'true');
    var pg = document.createElementNS(svgNS, 'polygon');
    pg.setAttribute('points', '44,0 22,38.1 -22,38.1 -44,0 -22,-38.1 22,-38.1');
    var c = document.createElementNS(svgNS, 'circle');
    c.setAttribute('r', '16');
    s.appendChild(pg);
    s.appendChild(c);
    return s;
  };
  var el = function (tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  var CHEV = 'm10 7 5 5-5 5';
  var BACK = 'm14 6-6 6 6 6';
  var ARROW = 'M5 12h13|M13 6l6 6-6 6';

  /* ------------------------------------------------------------------------
     1. The bar
     ------------------------------------------------------------------------ */
  var active = parseInt(bar.getAttribute('data-active'), 10);
  if (isNaN(active)) active = -1;
  var tabs = $$('[data-llmt-tab]', bar);

  var setInk = function (i, instant) {
    if (instant) bar.classList.add('no-anim');
    bar.style.setProperty('--i', String(Math.max(0, i)));
    bar.classList.toggle('has-ink', i >= 0);
    if (instant) { void bar.offsetWidth; bar.classList.remove('no-anim'); }
  };

  /* The ink slides to a tab the moment it is tapped, before the next page has
     even started loading, and the next page opens with it already there. */
  setInk(active, true);
  store.set('sessionStorage', 'llmt:at', String(active));
  window.addEventListener('pageshow', function (e) { if (e.persisted) setInk(active, true); });

  tabs.forEach(function (tab) {
    var i = parseInt(tab.getAttribute('data-llmt-tab'), 10);
    tab.addEventListener('click', function (e) {
      tab.classList.remove('is-pop');
      void tab.offsetWidth;
      tab.classList.add('is-pop');
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      /* Home, when already home: back to the top instead of a reload. */
      if (tab.hasAttribute('data-llmt-home') && active === 0 && window.pageYOffset > 40) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: calm.matches ? 'auto' : 'smooth' });
        return;
      }
      if (tab.hasAttribute('data-llmt-shop') || /\/search/.test(tab.getAttribute('href') || '')) return;
      setInk(i);
    });
    tab.addEventListener('animationend', function () { tab.classList.remove('is-pop'); });
  });

  /* Warm the next page while the finger is still down. Not the basket: a
     prefetched cart could be a stale cart. */
  var warmed = {};
  $$('[data-llmt-home], .llmt__tab--watch', bar).forEach(function (a) {
    a.addEventListener('touchstart', function () {
      var href = a.href;
      if (warmed[href] || a.getAttribute('aria-current')) return;
      warmed[href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      document.head.appendChild(l);
    }, { passive: true });
  });

  /* Typing into anything on the page: the bar steps aside so the keyboard and
     the field get the room. */
  var typing = function (t) {
    return t && t.matches && t.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select, [contenteditable="true"]') &&
      !t.closest('.llss, .llmts, .llh-drawer');
  };
  document.addEventListener('focusin', function (e) { if (typing(e.target)) bar.classList.add('is-away'); });
  document.addEventListener('focusout', function () {
    setTimeout(function () { if (!typing(document.activeElement)) bar.classList.remove('is-away'); }, 60);
  });

  /* ------------------------------------------------------------------------
     2. Watchlist badge
     ------------------------------------------------------------------------ */
  (function () {
    var tab = $('.llmt__tab--watch', bar);
    var badge = $('[data-llmt-watch-count]', bar);
    var sr = $('[data-llmt-watch-sr]', bar);
    if (!tab || !badge) return;
    var shown = -1;
    var read = function () {
      try {
        var raw = store.get('localStorage', 'll_watchlist');
        if (raw == null) raw = store.get('localStorage', 'll_preorder_watch');
        if (raw == null) raw = store.get('localStorage', 'll-ur-watch');
        var list = raw ? JSON.parse(raw) : [];
        if (Object.prototype.toString.call(list) !== '[object Array]') return 0;
        var seen = {}, n = 0;
        for (var i = 0; i < list.length; i++) {
          var h = String(list[i] || '').trim();
          if (h && !seen[h]) { seen[h] = 1; n++; }
        }
        return n;
      } catch (e) { return 0; }
    };
    var paint = function () {
      var n = read();
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.hidden = n < 1;
      if (sr) sr.textContent = n ? ', ' + n + (n === 1 ? ' item' : ' items') : '';
      if (shown > -1 && n > shown) {
        tab.classList.remove('is-ring');
        badge.classList.remove('is-bump');
        void tab.offsetWidth;
        tab.classList.add('is-ring');
        badge.classList.add('is-bump');
      }
      shown = n;
    };
    paint();
    document.addEventListener('ll:watchlist:change', paint);
    window.addEventListener('storage', function (e) {
      if (!e.key || /^(ll_watchlist|ll_preorder_watch|ll-ur-watch)$/.test(e.key)) paint();
    });
    setTimeout(paint, 1200);
  }());

  /* ------------------------------------------------------------------------
     3. Basket
     ------------------------------------------------------------------------ */
  (function () {
    var tab = $('[data-llmt-cart]', bar);
    if (!tab) return;
    var badge = $('[data-llmt-cart-count]', tab);
    var label = $('[data-llmt-cart-label]', tab);
    var sr = $('[data-llmt-cart-sr]', tab);
    var ring = $('[data-llmt-ring]', tab);
    var freeMin = parseInt(tab.getAttribute('data-free-min'), 10) || 0;
    var currency = tab.getAttribute('data-currency') || 'GBP';
    var fmt;
    try { fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }); }
    catch (e) { fmt = { format: function (v) { return '£' + v.toFixed(2); } }; }
    var money = function (minor) { return fmt.format((minor || 0) / 100); };
    var count = parseInt(badge ? badge.textContent : '0', 10) || 0;

    var paint = function (n, subtotal) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 0) return;
      subtotal = parseInt(subtotal, 10) || 0;
      var up = n > count;
      count = n;
      if (badge) {
        badge.textContent = n > 99 ? '99+' : String(n);
        badge.hidden = n === 0;
        badge.setAttribute('data-header-cart-count', n ? String(n) : '');
      }
      tab.classList.toggle('has-items', n > 0);
      if (label) label.textContent = n > 0 ? money(subtotal) : 'Basket';
      var pct = freeMin ? Math.min(100, Math.floor(subtotal * 100 / freeMin)) : 0;
      if (ring) ring.style.strokeDashoffset = String(100 - pct);
      tab.classList.toggle('is-free', !!freeMin && pct >= 100);
      if (sr) {
        var t = '';
        if (n > 0) {
          t = 'Basket, ' + n + (n === 1 ? ' item, ' : ' items, ') + money(subtotal);
          if (freeMin) t += pct >= 100 ? ', free UK delivery' : ', ' + money(freeMin - subtotal) + ' to free UK delivery';
        }
        sr.textContent = t;
      }
      if (up) {
        tab.classList.remove('is-drop');
        if (badge) badge.classList.remove('is-bump');
        void tab.offsetWidth;
        tab.classList.add('is-drop');
        if (badge) badge.classList.add('is-bump');
      }
    };
    tab.addEventListener('animationend', function () { tab.classList.remove('is-drop'); });

    var busy = false, again = false;
    var refresh = function () {
      if (busy) { again = true; return; }
      busy = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) paint(c.item_count, c.items_subtotal_price); })
        .catch(function () {})
        .then(function () { busy = false; if (again) { again = false; refresh(); } });
    };
    var soon = null;
    var refreshSoon = function () { clearTimeout(soon); soon = setTimeout(refresh, 150); };

    ['cart:updated', 'cart:refresh', 'cart:build', 'cartcount:update', 'll:cart:change', 'll:cart:updated',
     'll:cart:applied', 'theme:cart:change', 'ajaxProduct:added'].forEach(function (name) {
      var h = function (e) {
        var c = e && e.detail && (e.detail.cart || e.detail);
        if (c && typeof c.item_count === 'number' && typeof c.items_subtotal_price === 'number') paint(c.item_count, c.items_subtotal_price);
        else refreshSoon();
      };
      document.addEventListener(name, h);
      window.addEventListener(name, h);
    });

    /* Any cart write, from any script or app, is followed by a re-read. Both
       wrappers call straight through, so whatever else wrapped fetch keeps
       working. */
    var isCartWrite = function (url) { return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url); };
    if (window.fetch && !window.fetch.__llmt) {
      var origFetch = window.fetch;
      var wrapped = function () {
        var url = null;
        try { var a = arguments[0]; url = typeof a === 'string' ? a : a && a.url; } catch (e) {}
        var out = origFetch.apply(this, arguments);
        if (isCartWrite(url) && out && out.then) out.then(refreshSoon, function () {});
        return out;
      };
      wrapped.__llmt = true;
      window.fetch = wrapped;
    }
    var open = XMLHttpRequest.prototype.open;
    if (!open.__llmt) {
      var xo = function (method, url) {
        if (isCartWrite(url)) this.addEventListener('load', refreshSoon);
        return open.apply(this, arguments);
      };
      xo.__llmt = true;
      XMLHttpRequest.prototype.open = xo;
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }());

  /* ------------------------------------------------------------------------
     4. Shop sheet
     ------------------------------------------------------------------------ */
  (function () {
    var sheet = document.getElementById('ll-shop-sheet');
    var opener = $('[data-llmt-shop]', bar);
    if (!sheet || !opener) return;
    var panel = $('[data-llmts-panel]', sheet);
    var stack = $('[data-llmts-stack]', sheet);
    var root = $('[data-llmts-level="root"]', sheet);
    var levels = [root];
    var lastFocus = null;
    var isOpen = false;
    var hideTimer = null;

    var gPanel = function (n) { return document.getElementById('llh-panel-' + n); };
    var colorOf = function (node) { return node ? getComputedStyle(node).getPropertyValue('--g').trim() : ''; };

    /* Supplies from the header rail (Binders, Sleeves) join the list once. */
    (function () {
      var more = $('[data-llmts-more]', sheet);
      if (!more) return;
      var have = {};
      $$('a', more).forEach(function (a) { have[a.pathname] = 1; });
      $$('.llh-rail__extra-link').forEach(function (x) {
        if (have[x.pathname]) return;
        var li = el('li');
        var a = el('a', 'llmts__row');
        a.href = x.href;
        a.style.setProperty('--g', '#b3c4d6');
        a.appendChild(el('span', null, x.textContent.trim()));
        a.appendChild(icon(CHEV, 'llmts__chev'));
        li.appendChild(a);
        more.appendChild(li);
      });
    }());

    var makeLevel = function (title, color, backText, mark) {
      var sec = el('section', 'llmts__level');
      sec.style.setProperty('--g', color);
      var head = el('div', 'llmts__lhead');
      var back = el('button', 'llmts__back');
      back.type = 'button';
      back.setAttribute('data-llmts-back', '');
      back.appendChild(icon(BACK));
      back.appendChild(el('span', null, backText));
      head.appendChild(back);
      var t = el('p', 'llmts__ltitle');
      if (mark) t.appendChild(mark.cloneNode(true));
      t.appendChild(el('span', null, title));
      head.appendChild(t);
      sec.appendChild(head);
      var scroll = el('div', 'llmts__scroll');
      sec.appendChild(scroll);
      return { sec: sec, scroll: scroll };
    };
    var row = function (href, text, n) {
      var a = el(href ? 'a' : 'button', 'llmts__row');
      if (href) a.href = href; else a.type = 'button';
      a.appendChild(el('span', null, text));
      if (n) a.appendChild(el('span', 'llmts__n', String(n)));
      a.appendChild(icon(CHEV, 'llmts__chev'));
      return a;
    };
    var label = function (text) { return el('p', 'llmts__label', text); };

    var gameLevel = function (n) {
      var p = gPanel(n);
      if (!p) return null;
      var name = p.getAttribute('data-llh-title') || '';
      var color = colorOf(p);
      var lv = makeLevel(name, color, 'Shop', document.querySelector('[data-llh-tab="' + n + '"] .llh-tab__link .llh-mark'));
      var url = p.getAttribute('data-llh-url');
      var count = p.getAttribute('data-llh-count');

      /* Coming soon and Accessories have no picture of their own. On desktop
         their feature shows real products (the next releases, the best
         sellers), crossfading; this builds the same feature here and runs it
         through the header's own code (window.LLH.show in llh-header.js), so
         the two always agree and share one cached request. */
      var showSrc = $('[data-llh-show]', p);
      var ctaText = 'Shop all ' + name;
      if (showSrc && window.LLH && window.LLH.show) {
        lv.sec.classList.add('llmts__level--show');
        var box = el('div', 'llmts__show');
        box.setAttribute('data-llh-show', showSrc.getAttribute('data-llh-show'));
        box.setAttribute('data-llh-show-mode', showSrc.getAttribute('data-llh-show-mode'));
        var media = el('a', 'llmts__hero llmts__hero--show');
        media.href = url;
        media.setAttribute('aria-label', name);
        media.setAttribute('data-llh-show-link', '');
        media.appendChild(nut());
        var stage = el('span', 'llh-show');
        stage.setAttribute('data-llh-show-stage', '');
        stage.setAttribute('aria-hidden', 'true');
        media.appendChild(stage);
        if (count) media.appendChild(el('span', 'llmts__chip', count + ' items'));
        var pos = el('span', 'llh-show__n');
        pos.setAttribute('data-llh-show-n', '');
        pos.hidden = true;
        media.appendChild(pos);
        box.appendChild(media);
        var srcK = $('[data-llh-show-kicker]', showSrc);
        var srcM = $('[data-llh-show-meta]', showSrc);
        var kick = el('p', 'llmts__showk', srcK ? srcK.textContent.trim() : '');
        kick.setAttribute('data-llh-show-kicker', '');
        var meta = el('p', 'llmts__showm', srcM ? srcM.textContent.trim() : '');
        meta.setAttribute('data-llh-show-meta', '');
        box.appendChild(kick);
        box.appendChild(meta);
        lv.scroll.appendChild(box);
        var srcCta = $('.llh-feature__cta', p);
        if (srcCta && srcCta.textContent.trim()) ctaText = srcCta.textContent.trim();
        var sec = lv.sec;
        /* moves only while this level is the one on screen */
        sec.__show = window.LLH.show(box, function () {
          return isOpen && sec.classList.contains('is-active') && !!sec.parentNode;
        });
      } else {
        var hero = el('a', 'llmts__hero');
        hero.href = url;
        hero.setAttribute('aria-label', 'Shop all ' + name);
        var art = $('img[data-llh-art]', p);
        if (art) {
          var im = document.createElement('img');
          im.alt = '';
          im.decoding = 'async';
          /* the game card walls come in two sizes; the strip is the width of the phone */
          var wide = art.getAttribute('data-llh-art-wide');
          if (art.getAttribute('srcset')) {
            im.srcset = art.getAttribute('srcset');
            im.sizes = '100vw';
            im.className = 'is-wall';
          }
          if (wide) {
            /* a picture drawn for this 16:7 strip (Accessories): the whole scene, centred */
            im.srcset = wide;
            im.sizes = '100vw';
            im.src = wide.split(' ')[0];
          } else {
            im.src = art.getAttribute('src');
            im.style.objectPosition = art.style.objectPosition;
          }
          hero.appendChild(im);
        } else {
          hero.appendChild(nut());
        }
        if (count) hero.appendChild(el('span', 'llmts__chip', count + ' items'));
        lv.scroll.appendChild(hero);
      }

      var cta = el('a', 'llmts__cta');
      cta.href = url;
      cta.appendChild(el('span', null, ctaText));
      cta.appendChild(icon(ARROW));
      lv.scroll.appendChild(cta);

      var eras = $$('[data-llh-era]', p);
      if (eras.length) {
        var firstSet = $('.llh-sets__group .llh-set', p);
        if (firstSet) {
          var nw = el('a', 'llmts__newest');
          nw.href = firstSet.href;
          var tx = el('span');
          tx.appendChild(el('small', null, 'Newest set'));
          tx.appendChild(el('b', null, firstSet.textContent.trim()));
          nw.appendChild(tx);
          nw.appendChild(icon(CHEV, 'llmts__chev'));
          lv.scroll.appendChild(nw);
        }
        lv.scroll.appendChild(label('Series'));
        var list = el('ul', 'llmts__rows');
        eras.forEach(function (era) {
          var k = era.getAttribute('data-llh-era');
          var group = $('[data-llh-sets="' + k + '"]', p);
          var sets = group ? $$('.llh-set', group) : [];
          var eraName = ($('.llh-era__name', era) || era).textContent.trim();
          var li = el('li');
          if (sets.length) {
            var b = row(null, eraName, sets.length);
            b.addEventListener('click', function () { push(setsLevel(name, color, eraName, era.href, sets), b); });
            li.appendChild(b);
          } else {
            li.appendChild(row(era.href, eraName));
          }
          list.appendChild(li);
        });
        lv.scroll.appendChild(list);
      } else {
        var items = $$('.llh-grid__item', p);
        if (items.length) {
          lv.scroll.appendChild(label('Ranges'));
          var ul = el('ul', 'llmts__rows');
          items.forEach(function (a) {
            var nm = $('.llh-grid__name', a);
            var cnt = $('.llh-grid__n', a);
            var li = el('li');
            li.appendChild(row(a.href, (nm || a).textContent.trim(), cnt ? cnt.textContent.replace(/[^0-9]/g, '') : ''));
            ul.appendChild(li);
          });
          lv.scroll.appendChild(ul);
        }
      }
      return lv.sec;
    };

    var setsLevel = function (game, color, eraName, eraUrl, sets) {
      var lv = makeLevel(eraName, color, game, null);
      var all = el('a', 'llmts__all');
      all.href = eraUrl;
      var t = el('span');
      t.appendChild(document.createTextNode('All ' + eraName));
      t.appendChild(el('small', null, sets.length + (sets.length === 1 ? ' set' : ' sets')));
      all.appendChild(t);
      all.appendChild(icon(CHEV, 'llmts__chev'));
      lv.scroll.appendChild(all);
      lv.scroll.appendChild(label('Sets'));
      var grid = el('ul', 'llmts__sets');
      sets.forEach(function (s) {
        var li = el('li');
        var a = el('a', 'llmts__set', s.textContent.trim());
        a.href = s.href;
        li.appendChild(a);
        grid.appendChild(li);
      });
      lv.scroll.appendChild(grid);
      return lv.sec;
    };

    var push = function (sec, from, instant) {
      if (!sec) return;
      var top = levels[levels.length - 1];
      sec.__from = from || null;
      stack.appendChild(sec);
      levels.push(sec);
      if (instant) sheet.classList.add('no-anim');
      void sec.offsetWidth;
      top.classList.remove('is-active');
      top.classList.add('is-behind');
      sec.classList.add('is-active');
      if (instant) { void sec.offsetWidth; sheet.classList.remove('no-anim'); }
      var back = $('[data-llmts-back]', sec);
      if (back && !instant) setTimeout(function () { back.focus({ preventScroll: true }); }, 60);
    };
    var pop = function () {
      if (levels.length < 2) return;
      var top = levels.pop();
      var prev = levels[levels.length - 1];
      top.classList.remove('is-active');
      prev.classList.remove('is-behind');
      prev.classList.add('is-active');
      setTimeout(function () { if (top.parentNode) top.parentNode.removeChild(top); }, 460);
      if (top.__from && top.__from.focus) top.__from.focus({ preventScroll: true });
    };
    var reset = function () {
      while (levels.length > 1) {
        var l = levels.pop();
        if (l.parentNode) l.parentNode.removeChild(l);
      }
      root.classList.remove('is-behind');
      root.classList.add('is-active');
      var sc = $('.llmts__scroll', root);
      if (sc) sc.scrollTop = 0;
    };

    var open = function () {
      if (isOpen) return;
      clearTimeout(hideTimer);
      isOpen = true;
      lastFocus = document.activeElement;
      reset();
      sheet.hidden = false;
      panel.style.transform = '';
      void panel.offsetHeight;
      sheet.classList.add('is-open');
      document.documentElement.classList.add('llmt-lock');
      opener.setAttribute('aria-expanded', 'true');
      if (window.LLH && window.LLH.warmShow) $$('.llh-panel [data-llh-show]').forEach(window.LLH.warmShow);
      setInk(1);
      setTimeout(function () { var x = $('.llmts__x', sheet); if (x) x.focus({ preventScroll: true }); }, 80);
    };
    var close = function () {
      if (!isOpen) return;
      isOpen = false;
      sheet.classList.remove('is-open');
      sheet.classList.remove('is-dragging');
      panel.style.transform = '';
      document.documentElement.classList.remove('llmt-lock');
      opener.setAttribute('aria-expanded', 'false');
      setInk(active);
      hideTimer = setTimeout(function () { sheet.hidden = true; reset(); }, 460);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    opener.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen) close(); else open();
    });
    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-llmts-close]')) { close(); return; }
      if (t.closest('[data-llmts-back]')) { pop(); return; }
      var g = t.closest('[data-llmts-game]');
      if (g) {
        var lv = gameLevel(g.getAttribute('data-llmts-game'));
        if (lv) {
          e.preventDefault();
          push(lv, g);
          if (lv.__show) lv.__show.play();
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); if (levels.length > 1) pop(); else close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled])', panel).filter(function (n) {
        return n.offsetParent !== null && getComputedStyle(n).visibility !== 'hidden';
      });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    /* Drag down to dismiss: from the handle and title, or from the list when it
       is already scrolled to the top. A third of the way, or a flick, closes.
       Every touch starts its own gesture. A touch on a list that is scrolled
       is a scroll from start to finish; returning early used to leave the last
       gesture's start point and list behind, and after a trip into a game that
       list was the game's, removed from the page, so it read scrollTop 0 and
       the main menu's swipes dragged the sheet (owner, 5 Oct 2026). */
    var y0 = 0, y1 = 0, t0 = 0, drag = false, decided = false, fromList = null;
    panel.addEventListener('touchstart', function (e) {
      drag = false;
      decided = true;
      fromList = null;
      if (!isOpen || e.touches.length !== 1) return;
      var t = e.target;
      var scroller = t.closest && t.closest('.llmts__scroll');
      if (scroller && scroller.scrollTop > 0) return;
      fromList = scroller;
      y0 = y1 = e.touches[0].clientY;
      t0 = Date.now();
      decided = !scroller;
      if (decided) { drag = true; sheet.classList.add('is-dragging'); }
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!isOpen || e.touches.length !== 1) return;
      y1 = e.touches[0].clientY;
      var dy = y1 - y0;
      if (!decided) {
        if (Math.abs(dy) < 6) return;
        decided = true;
        drag = dy > 0 && (!fromList || fromList.scrollTop <= 0);
        if (drag) sheet.classList.add('is-dragging');
      }
      if (!drag) return;
      if (e.cancelable) e.preventDefault();
      panel.style.transform = 'translate3d(0,' + Math.max(0, dy) + 'px,0)';
    }, { passive: false });
    var end = function () {
      if (!drag) return;
      drag = false;
      decided = false;
      sheet.classList.remove('is-dragging');
      var dy = y1 - y0;
      var flick = Date.now() - t0 < 280 && dy > 50;
      if (dy > panel.offsetHeight / 3 || flick) close();
      else panel.style.transform = '';
    };
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }());

  /* ------------------------------------------------------------------------
     5. Search sheet: "New in store" from the header's rolling search hints
     ------------------------------------------------------------------------ */
  (function () {
    var box = $('[data-llss-trending]');
    var list = $('[data-llss-trending-list]');
    var src = $('[data-llh-hints]');
    if (!box || !list || !src) return;
    var hints = [];
    try { hints = JSON.parse(src.textContent || '[]'); } catch (e) { hints = []; }
    hints = hints.filter(function (h) { return typeof h === 'string' && h.trim(); }).slice(0, 5);
    if (!hints.length) return;
    hints.forEach(function (h) {
      var li = el('li');
      var a = el('a', 'llss__chip');
      a.href = '/search?q=' + encodeURIComponent(h) + '&type=product&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last';
      a.appendChild(icon('M16.2 16.2 20.3 20.3|M11 4.4a6.6 6.6 0 1 0 0 13.2 6.6 6.6 0 0 0 0-13.2Z'));
      a.appendChild(el('span', null, h));
      li.appendChild(a);
      list.appendChild(li);
    });
    box.hidden = false;
    /* Typing takes over the sheet: the list steps aside like Recent and Browse do. */
    var input = $('[data-llss-input]');
    if (input) input.addEventListener('input', function () { box.hidden = input.value.trim().length >= 2; });
  }());
}());
